import type { InMemoryCache, Reference } from '@apollo/client';
import type { ReadFieldFunction } from '@apollo/client/cache/core/types/common';

import { sendErrorEvent } from '@trello/error-reporting';

import type { TrelloAttachment } from '../generated';
import { isBool } from '../plannerCardDataMapping/validateHelpers';
import type { RecursivePartial, TargetModel } from './cacheModelTypes';
import { getObjectIdFromCacheObject } from './getObjectIdFromCacheObject';
import { syncNativeToRestScalars } from './syncNativeToRestScalars';

/** Exported for testing purposes only */
export const scalarFieldMappings = {
  isMalicious: { validate: isBool },
};

/**
 * Given native TrelloAttachment data, writes all attachment data to the Attachment model
 * in the Apollo Cache
 * @param incoming A partial TrelloAttachment model
 * @param cache The cache to write to
 * @param readField A function to read fields from the cache
 */
export const syncTrelloAttachmentToAttachment = (
  incoming: RecursivePartial<TrelloAttachment> | Reference,
  cache: InMemoryCache,
  readField: ReadFieldFunction,
) => {
  const attachment: TargetModel = { id: '', type: 'Attachment' };
  try {
    const attachmentId = getObjectIdFromCacheObject(incoming, readField);
    attachment.id = attachmentId;

    syncNativeToRestScalars(
      attachment,
      scalarFieldMappings,
      incoming,
      cache,
      readField,
    );
  } catch (err) {
    sendErrorEvent(err);
  }
};
